import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Login from "@/components/Login";
import ForcedPasswordChange from "@/components/ForcedPasswordChange";
import Layout from "@/components/Layout";
import Weekritme from "@/pages/Weekritme";
import LocatieCall from "@/pages/LocatieCall";
import Afspraken from "@/pages/Afspraken";
import Overzicht from "@/pages/Overzicht";
import Weekrapport from "@/pages/Weekrapport";
import Settings from "@/pages/Settings";
import MijnPunten from "@/pages/MijnPunten";
import Voorbereiding from "@/pages/Voorbereiding";
import MijnWeekritme from "@/pages/MijnWeekritme";
import LocatieAccounts from "@/pages/LocatieAccounts";
import Vandaag from "@/pages/Vandaag";
import Handleiding from "@/pages/Handleiding";
import Bezoeken from "@/pages/Bezoeken";
import BezoekPagina from "@/pages/BezoekPagina";
import Afdelingen from "@/pages/Afdelingen";
import AfdelingVandaag from "@/pages/AfdelingVandaag";
import AfdelingAfspraken from "@/pages/AfdelingAfspraken";

// v19-C1: dezelfde paden, eigen schermen voor de afdeling (de server is de echte bewaker).
const PerRol = ({ afdeling, anders }) => (useAuth().user?.role === "afdeling" ? afdeling : anders);

function homeFor(user) {
  return user?.role === "bedrijfsleider" ? "/mijn-punten" : "/vandaag";
}

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user)} replace />;
  return <Layout>{children}</Layout>;
}

function Root() {
  const { user } = useAuth();
  if (!user) return <Login />;
  return <Navigate to={homeFor(user)} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Shell />
      </AuthProvider>
    </div>
  );
}

function Shell() {
  const { user } = useAuth();
  // Geforceerde wachtwoordwijziging gaat vóór alle routes: geen navigatie mogelijk tot het gebeurd is.
  if (user && user.mustChangePassword) return <ForcedPasswordChange />;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Root />} />
        <Route path="/vandaag" element={<Protected roles={["om", "oversight", "afdeling"]}><PerRol afdeling={<AfdelingVandaag />} anders={<Vandaag />} /></Protected>} />
        <Route path="/weekritme" element={<Protected roles={["om", "oversight", "afdeling"]}><PerRol afdeling={<MijnWeekritme />} anders={<Weekritme />} /></Protected>} />
        <Route path="/locatie-call" element={<Protected roles={["om", "oversight"]}><LocatieCall /></Protected>} />
        <Route path="/afspraken" element={<Protected roles={["om", "oversight", "afdeling"]}><PerRol afdeling={<AfdelingAfspraken />} anders={<Afspraken />} /></Protected>} />
        <Route path="/weekrapport" element={<Protected roles={["om", "oversight"]}><Weekrapport /></Protected>} />
        <Route path="/locatie-accounts" element={<Protected roles={["om"]}><LocatieAccounts /></Protected>} />
        <Route path="/mijn-punten" element={<Protected roles={["bedrijfsleider"]}><MijnPunten /></Protected>} />
        <Route path="/mijn-weekritme" element={<Protected roles={["bedrijfsleider"]}><MijnWeekritme /></Protected>} />
        <Route path="/voorbereiding" element={<Protected roles={["bedrijfsleider"]}><Voorbereiding /></Protected>} />
        <Route path="/overzicht" element={<Protected roles={["om", "oversight"]}><Overzicht /></Protected>} />
        <Route path="/bezoeken" element={<Protected roles={["om", "oversight", "bedrijfsleider"]}><Bezoeken /></Protected>} />
        <Route path="/bezoeken/:id" element={<Protected roles={["om", "oversight", "bedrijfsleider"]}><BezoekPagina /></Protected>} />
        <Route path="/instellingen" element={<Protected roles={["oversight"]}><Settings /></Protected>} />
        <Route path="/afdelingen" element={<Protected roles={["oversight"]}><Afdelingen /></Protected>} />
        <Route path="/handleiding" element={<Protected roles={["om", "oversight", "bedrijfsleider", "afdeling"]}><Handleiding /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
